<p-button
  [label]="loading ? '' : label"
  [disabled]="isDisabled"
  [ngClass]="getButtonClasses()"
  [type]="type"
  [ariaLabel]="resolvedAriaLabel"
  [attr.aria-busy]="loading ? true : null"
  [routerLink]="routerLink"
  [style.--button-custom-color]="color"
  class="custom-button"
  (click)="handleClick($event)">
  <ng-container *ngIf="loading">
    <span class="custom-spinner" aria-hidden="true"></span>
  </ng-container>
  <ng-container *ngIf="!loading && icon">
    <lucide-icon [name]="icon" class="custom-icon"></lucide-icon>
  </ng-container>
</p-button>
